(function () {
  'use strict';

  var TARGET_ID = 'bob-free-shipping-progress';
  var EXCLUDED_HANDLES = ['award-winning-pasta-madre-sourdough'];
  var US_THRESHOLD_CENTS = 3500;
  var CA_THRESHOLD_CENTS = 7900;
  var STYLE_ID = 'bob-free-shipping-progress-styles';
  var EMPTY_CART_TEXT = 'Your cart is empty';
  var updateTimer = null;

  function styleEmptyCartMessage(root) {
    if (!root) return;

    var candidates = [];

    if (root.nodeType === 1) {
      candidates.push(root);

      if (root.querySelectorAll) {
        Array.prototype.push.apply(
          candidates,
          root.querySelectorAll('div, p, span, h1, h2, h3, h4')
        );
      }
    } else if (root === document) {
      candidates = Array.prototype.slice.call(
        document.querySelectorAll('div, p, span, h1, h2, h3, h4')
      );
    }

    candidates.forEach(function (element) {
      if ((element.textContent || '').replace(/\s+/g, ' ').trim() !== EMPTY_CART_TEXT) {
        return;
      }

      element.style.setProperty('color', '#ffffff', 'important');
    });
  }

  function getTarget() {
    return document.getElementById(TARGET_ID);
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#' + TARGET_ID + '{width:100%;box-sizing:border-box;font:inherit;color:inherit;}',
      '#' + TARGET_ID + ' .bob-free-shipping__message{font:inherit;font-weight:600;line-height:1.35;text-align:center;margin:0;}',
      '#' + TARGET_ID + ' .bob-free-shipping__track{width:100%;height:8px;margin:10px 0 0;border-radius:999px;background:rgba(255,255,255,.14);overflow:hidden;}',
      '#' + TARGET_ID + ' .bob-free-shipping__fill{display:block;height:100%;width:var(--bob-free-shipping-progress,0%);border-radius:inherit;background:#00a65a;transition:width .2s ease;}',
      '#' + TARGET_ID + ' .bob-free-shipping__note{font:inherit;font-size:.82em;line-height:1.35;text-align:center;opacity:.72;margin:8px 0 0;}',
      '#' + TARGET_ID + ' .bob-free-shipping__pasta-only{font:inherit;font-weight:600;line-height:1.4;text-align:center;margin:0;}'
    ].join('');

    document.head.appendChild(style);
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(currency === 'CAD' ? 'en-CA' : 'en-US', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  function getCart() {
    return window.fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function buildState(cart, excludePastaMadre) {
    var pastaMadrePresent = false;
    var eligibleSubtotal = 0;
    var eligibleItemCount = 0;

    (cart.items || []).forEach(function (item) {
      var handle = item.handle || '';
      var isPastaMadre = EXCLUDED_HANDLES.indexOf(handle) !== -1;

      if (isPastaMadre) {
        pastaMadrePresent = true;

        if (excludePastaMadre) {
          return;
        }
      }

      eligibleSubtotal += Number(item.final_line_price || 0);
      eligibleItemCount += Number(item.quantity || 0);
    });

    return {
      pastaMadrePresent: pastaMadrePresent,
      eligibleSubtotal: eligibleSubtotal,
      eligibleItemCount: eligibleItemCount
    };
  }

  function render(cart) {
    var target = getTarget();
    if (!target) return;

    if (!cart || (cart.currency !== 'USD' && cart.currency !== 'CAD')) {
      target.innerHTML = '';
      target.hidden = true;
      delete target.dataset.bobSignature;
      return;
    }

    var isCanada = cart.currency === 'CAD';
    var threshold = isCanada ? CA_THRESHOLD_CENTS : US_THRESHOLD_CENTS;
    var state = buildState(cart, !isCanada);

    var signature = [
      cart.currency,
      state.pastaMadrePresent ? '1' : '0',
      state.eligibleSubtotal,
      state.eligibleItemCount
    ].join('|');

    if (target.dataset.bobSignature === signature && target.innerHTML) return;

    target.dataset.bobSignature = signature;
    target.hidden = false;
    ensureStyles();

    if (!isCanada && state.pastaMadrePresent && state.eligibleItemCount === 0) {
      target.innerHTML =
        '<p class="bob-free-shipping__pasta-only">' +
          'Pasta Madre ships separately with free 2-day shipping.' +
        '</p>';
      return;
    }

    var remaining = Math.max(0, threshold - state.eligibleSubtotal);
    var progress = Math.min(
      100,
      Math.max(0, (state.eligibleSubtotal / threshold) * 100)
    );

    var message = remaining > 0
      ? "You're " + formatMoney(remaining, cart.currency) + ' away from free shipping!'
      : 'Free shipping unlocked!';

    target.style.setProperty(
      '--bob-free-shipping-progress',
      progress.toFixed(2) + '%'
    );

    var note = '';

    if (isCanada) {
      note = '<p class="bob-free-shipping__note">Remote area exclusions apply.</p>';
    } else if (state.pastaMadrePresent) {
      note =
        '<p class="bob-free-shipping__note">' +
          'Pasta Madre ships separately with free 2-day shipping and does not count toward the $35 minimum.' +
        '</p>';
    }

    target.innerHTML =
      '<p class="bob-free-shipping__message">' + message + '</p>' +
      '<div class="bob-free-shipping__track" aria-hidden="true">' +
        '<span class="bob-free-shipping__fill"></span>' +
      '</div>' +
      note;
  }

  function update() {
    if (!getTarget()) return;

    getCart().then(render).catch(function () {
      // Fail open: do not interfere with the rest of UpCart.
    });
  }

  function scheduleUpdate(delay) {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(update, typeof delay === 'number' ? delay : 100);
  }

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var args = arguments;
      var request = args[0];
      var url = typeof request === 'string' ? request : (request && request.url) || '';

      return originalFetch.apply(this, args).then(function (response) {
        if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/i.test(url)) {
          scheduleUpdate(20);
        }

        return response;
      });
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bobCartMutation =
      /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/i.test(String(url || ''));

    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__bobCartMutation) {
      this.addEventListener('loadend', function () {
        scheduleUpdate(20);
      }, { once: true });
    }

    return originalSend.apply(this, arguments);
  };

  var observer = new MutationObserver(function (mutations) {
    var placeholderAdded = false;

    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (!node || node.nodeType !== 1) return;

        styleEmptyCartMessage(node);

        if (
          node.id === TARGET_ID ||
          (node.querySelector && node.querySelector('#' + TARGET_ID))
        ) {
          placeholderAdded = true;
        }
      });
    });

    if (placeholderAdded) scheduleUpdate(0);
  });

  function init() {
    styleEmptyCartMessage(document);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    scheduleUpdate(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();